<template>
  <message-view
    :title="$t('expired.title')"
    :message="getMessage()"
    :footer="
      $t('expired.expired-range', {
        start: friendlyStartDate,
        end: friendlyExpirationDate
      })
    "
    class="text-center"
  />
</template>

<script>
import MessageView from './shared/MessageView'

export default {
  name: 'ExpiredView',
  components: {
    MessageView
  },
  props: {
    rewardLink: {
      type: Object,
      required: true
    }
  },
  computed: {
    createdAtAsDate () {
      // return in ISO 8601 format (https://en.wikipedia.org/wiki/ISO_8601 unless someone wants to buy a copy of https://www.iso.org/standard/40874.html)
      return this.rewardLink.createdAt
        ? new Date(this.rewardLink.createdAt)
        : ''
    },
    expirationDateAsDate () {
      // return in ISO 8601 format (https://en.wikipedia.org/wiki/ISO_8601 unless someone wants to buy a copy of https://www.iso.org/standard/40874.html)
      return this.rewardLink.expirationDate
        ? new Date(this.rewardLink.expirationDate)
        : ''
    },
    friendlyExpirationDate () {
      return this.expirationDateAsDate
        ? this.expirationDateAsDate.toLocaleTimeString('en-US', {
          month: 'long',
          hour12: true,
          year: 'numeric',
          day: 'numeric',
          timeZoneName: 'short',
          hour: 'numeric',
          minute: '2-digit'
        })
        : ''
    },
    friendlyStartDate () {
      return this.createdAtAsDate
        ? this.createdAtAsDate.toLocaleTimeString('en-US', {
          month: 'long',
          hour12: true,
          year: 'numeric',
          day: 'numeric',
          timeZoneName: 'short',
          hour: 'numeric',
          minute: '2-digit'
        })
        : ''
    }
  },
  methods: {
    getMessage () {
      const { expirationMessage } = this.rewardLink.customization || {}
      return expirationMessage || this.$t('expired.message')
    }
  }
}
</script>
